import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveBounce12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMoveBounce12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M8.33 1.469a2.7 2.7 0 0 1 2.424 2.686l-.015.275a2.7 2.7 0 0 1-2.685 2.425l-.277-.014a3 3 0 0 1-.262-.041L6.098 9.419h3.59a.45.45 0 0 1 0 .9H2.31a.45.45 0 0 1 0-.9h1.704L2.426 7.042a.451.451 0 0 1 .748-.501l1.91 2.858 1.584-2.927a2.7 2.7 0 0 1-1.3-2.042l-.014-.275a2.7 2.7 0 0 1 2.7-2.7zm-.276.886a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 0 0 0-3.6M1.296 4.472a.45.45 0 0 1 .624.124l.284.424a.45.45 0 0 1-.749.5l-.283-.424a.45.45 0 0 1 .124-.625"
            />
        </svg>
    );
}
export default memo(IconMoveBounce12);
